import { GET_OAUTH } from '../actions';

export default (state = null, action) => {
  switch (action.type) {
    case GET_OAUTH:
      return action.payload.data || null;
    default:
      return state;
  }
};
